import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { MapPin, Mail, Phone, Linkedin, Twitter } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_teamcraft-app-2/artifacts/k6trts4z_Bitmap%20blanc.png';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-[#1A1A1A] text-white" data-testid="footer">
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          {/* Brand Column */}
          <div className="md:col-span-4">
            <img src={LOGO_URL} alt="TeamCraft" className="h-40 w-auto mb-6" />
          </div>

          {/* Navigation Links */}
          <div className="md:col-span-2">
            <h4 className="font-semibold mb-4 text-[#C5A059]">Navigation</h4>
            <div className="flex flex-col gap-3">
              <Link to="/" className="text-gray-400 hover:text-white text-sm transition-colors">
                {t('nav.home')}
              </Link>
              <Link to="/about" className="text-gray-400 hover:text-white text-sm transition-colors">
                {t('nav.about')}
              </Link>
              <Link to="/services" className="text-gray-400 hover:text-white text-sm transition-colors">
                {t('nav.services')}
              </Link>
              <Link to="/diagnosis" className="text-gray-400 hover:text-white text-sm transition-colors">
                {t('nav.diagnosis')}
              </Link>
            </div>
          </div>

          {/* Services Links */}
          <div className="md:col-span-3">
            <h4 className="font-semibold mb-4 text-[#C5A059]">Services</h4>
            <div className="flex flex-col gap-3">
              <Link to="/services#recruitment" className="text-gray-400 hover:text-white text-sm transition-colors">
                {t('services.recruitment.title')}
              </Link>
              <Link to="/services#team-dynamics" className="text-gray-400 hover:text-white text-sm transition-colors">
                {t('services.teamDynamics.title')}
              </Link>
              <Link to="/services#leadership" className="text-gray-400 hover:text-white text-sm transition-colors">
                {t('services.leadership.title')}
              </Link>
            </div>
          </div>

          {/* Contact */}
          <div className="md:col-span-3">
            <h4 className="font-semibold mb-4 text-[#C5A059]">Contact</h4>
            <div className="flex flex-col gap-3">
              <a href="mailto:contact@teamcraft.lu" className="flex items-center gap-2 text-gray-400 hover:text-white text-sm transition-colors">
                <Mail className="w-4 h-4" />
                contact@teamcraft.lu
              </a>
              <a href="tel:+352123456789" className="flex items-center gap-2 text-gray-400 hover:text-white text-sm transition-colors">
                <Phone className="w-4 h-4" />
                +352 123 456 789
              </a>
              <div className="flex gap-4 mt-4">
                <a 
                  href="https://www.linkedin.com/company/teamcraft-luxembourg" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-gray-400 hover:text-[#C5A059] transition-colors"
                  aria-label="Visit TeamCraft Luxembourg on LinkedIn"
                >
                  <Linkedin className="w-5 h-5" />
                </a>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#C5A059] transition-colors" aria-label="Visit TeamCraft on Twitter">
                  <Twitter className="w-5 h-5" />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">{t('footer.copyright')}</p>
          <div className="flex gap-6">
            <Link to="/privacy" className="text-gray-500 hover:text-white text-sm transition-colors">
              {t('footer.privacy')}
            </Link>
            <Link to="/terms" className="text-gray-500 hover:text-white text-sm transition-colors">
              {t('footer.terms')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
